import React from 'react';
import { useSelector } from 'react-redux';
import {
  headerTabEULinking,
  itemsTabLinking,
  transportTabEULinking,
  containersTabLinking
} from '@commonComponents/utils/errorMessageLink.js';
import DisplayErrorServer from '@commonComponents/DisplayErrorServer'

const DisplayErrorServerDMS = () => {
  const serverErrors = useSelector((state) => state.serverErrorReducer) || {}
  const isErrors = Object.entries(serverErrors)?.some(([_, tabErrors])=> !!tabErrors?.length)
  
  const handleErrorFocus = (tab, error) => {
    if (tab === 'header') headerTabEULinking(error)
    if (tab === 'transport') transportTabEULinking(error)
    if (tab === 'containers') containersTabLinking(error)
    if (tab === 'items') itemsTabLinking(error)
  }

  return isErrors ? <DisplayErrorServer
    serverErrors={serverErrors}
    handleErrorFocus={handleErrorFocus}
  /> : null
}

export default DisplayErrorServerDMS